var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.85911 18.0009C9.72199 18.0004 9.58643 17.9718 9.46085 17.9168C9.33527 17.8617 9.22235 17.7814 9.12911 17.6809L4.26911 12.5109C4.08744 12.3173 3.99011 12.0594 3.99855 11.7941C4.00699 11.5287 4.1205 11.2776 4.31411 11.0959C4.50772 10.9142 4.76557 10.8169 5.03093 10.8253C5.29629 10.8338 5.54744 10.9473 5.72911 11.1409L9.84911 15.5309L18.2591 6.33089C18.3445 6.22461 18.4506 6.1369 18.5711 6.07315C18.6916 6.0094 18.8238 5.97095 18.9597 5.96017C19.0956 5.94938 19.2322 5.96649 19.3612 6.01044C19.4903 6.05439 19.6089 6.12425 19.71 6.21573C19.811 6.30722 19.8923 6.41839 19.9488 6.54243C20.0053 6.66647 20.0359 6.80075 20.0386 6.93703C20.0413 7.0733 20.0162 7.2087 19.9647 7.3349C19.9132 7.4611 19.8364 7.57543 19.7391 7.67089L10.5991 17.6709C10.5068 17.7732 10.3942 17.8554 10.2686 17.9122C10.143 17.969 10.007 17.9992 9.86911 18.0009H9.85911Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic_check.bb89037f780cf13f06208a386b5f897f.svg";
export { ForwardRef as ReactComponent };